import { Upload } from "../types";
import { defineStore } from "pinia";
import { useSessionStorage } from "@vueuse/core";

export const useUploadsStore = defineStore("uploads", {
  state: () => ({
    uploads: useSessionStorage<Upload[]>("uploads", []),
  }),
  getters: {
    hasPendingUploads: (state) => {
      return state.uploads.some((upload) => upload.status === "uploading");
    },
    isUploadingFiles: (state) => {
      return state.uploads.some((upload) => upload.total - upload.loaded > 0);
    },
  },
  actions: {
    clearAllUploads() {
      this.uploads = [];
    },
  },
});
